import { gqlRequest } from './api';

export const orderService = {
  async getOrders({ id, page = 1, pageSize = 10, sortBy, sortAsc, status, startDate, endDate } = {}) {
    const data = await gqlRequest(`
      query MyOrders(
        $id: Int, $page: Int, $pageSize: Int,
        $sortBy: String, $sortAsc: Boolean,
        $status: [String], $startDate: String, $endDate: String
      ) {
        myOrders(
          id: $id, page: $page, pageSize: $pageSize,
          sortBy: $sortBy, sortAsc: $sortAsc,
          status: $status, startDate: $startDate, endDate: $endDate
        ) {
          page
          morePages
          orders {
            id
            startDate
            email
            orderStatus
            needsAttention
            totals { subtotal discount tax shipping fee grand }
            items {
              id sku name price qtyOrdered total itemStatus
              shipments {
                id trackingNumber carrierService
                estimatedDeliveryDate actualDeliveryDate
              }
            }
            shipping {
              firstname lastname company street complement
              city regionCode countryId postcode
            }
            payment { methodTitle methodCode }
            businessInfo { poNumber glCode location }
            notes { id note isVisibleToCustomer createdAt }
            histories { id event message status createdAt }
          }
        }
      }
    `, { id, page, pageSize, sortBy, sortAsc, status, startDate, endDate },
    { requireAuth: true });

    const result = data.myOrders;
    return {
      resultCount: (result.orders || []).length,
      hits: (result.orders || []).map(order => ({
        ...order,
        items: (order.items || []).map(item => ({
          ...item,
          qty: item.qtyOrdered,
          totalPrice: item.total
        }))
      })),
      page: result.page,
      morePages: result.morePages
    };
  },

  async getOrderById(orderId) {
    const result = await orderService.getOrders({ id: orderId });
    const orders = result?.hits || [];
    return orders[0] || null;
  }
};
